module.exports = __webpack_public_path__ + "img/yunqiao_bg.ced04f77.png";